import * as React from 'react'
import Dropzone from 'react-dropzone'

import { Avatar, EnhancedDimension, Icon, Tooltip } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import styles from 'modules/core/components/AvatarUploader/index.module.scss'
import buildUrl from 'modules/core/lib/buildUrl'

type UploaderSizes = 's120' | 's80'

interface Props {
  value?: File | string | null
  onChange?: (file: File | null) => void
  readonly?: boolean
  size?: EnhancedDimension & UploaderSizes
  error?: string | null
}

const cx = classNames.bind(styles)

/* A poor man's version of the AvatarUploader component in core, but one that
doesn't rely on factorial-form and hence is less coupled to mobx-rest. Ideally
this will be replaced by a F1 component. */
const AvatarUploader = ({ value, onChange, readonly, size = 's120', error }: Props) => {
  const onDrop = (files: File[]) => {
    onChange?.(files[0] || null)
  }

  const renderImage = () => {
    if (!value) return null

    if (value instanceof File) {
      return <img src={URL.createObjectURL(value)} className={styles.image} />
    }

    if (typeof value === 'string') {
      return (
        <div className={styles.avatar}>
          <Avatar url={buildUrl(value)} size={size} label="" />
          <div className={styles.hover} />
        </div>
      )
    }

    return null
  }

  const renderFile = (illustration: React.ComponentProps<typeof Icon.Large>['icon']) => {
    if (!value) {
      return (
        <div className={styles.illustration}>
          <Icon.Large icon={illustration} />
        </div>
      )
    }

    if (value instanceof File) {
      return (
        <Tooltip attachment="bottom center" type="wrong" open={Boolean(error)}>
          {renderImage()}
          <Tooltip.Pad>{error}</Tooltip.Pad>
        </Tooltip>
      )
    }

    return renderImage()
  }

  if (readonly) {
    return <div className={cx('avatarReadonly', size)}>{renderFile('add-avatar')}</div>
  }

  return (
    <Dropzone onDrop={onDrop} multiple={false}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={cx('avatarUploader', size)}>
          <input {...getInputProps()} />
          {renderFile('add-avatar')}
        </div>
      )}
    </Dropzone>
  )
}

export default AvatarUploader
